import api from "../index";

export const getAllPermissions = (params) => api.get("/permission/get", { params });
export const updatePermissions = (data) => api.post("/permission/update", data);
